var render = function render(){var _vm=this,_c=_vm._self._c;return _c('toggle-unmatched-records',{staticClass:"toggle-unmatched-broadcasts",attrs:{"is-nested":"","unmatched-count":_vm.unmatchedCount(_vm.station),"disabled":_vm.loadingContentBroadcasts(_vm.station.content_id),"resource-type":"broadcast"},on:{"toggle-unmatched-records":_vm.toggleUnmatchedBroadcasts}})
}
var staticRenderFns = []

export { render, staticRenderFns }